<template>
    <div class="help_box">
        <div class="header">
            <p v-for="(item,index) in headerList"
               :key="index"
               @click="toCheckActive(item,index)"
               :class="{'active':isActive==index}">{{item.name}}<span class="line"
                                                                      v-show="isActive==index"></span>
            </p>
        </div>
        <div class="content">
            <!-- <transition-group name="move"> -->
            <div class="item"
                 v-for="(item,index) in contentList"
                 :key="index"
                 @click="toShowCon(item)">
                <p class="title"
                   :class="{'titleNoPadd':isShowCon==item.id}">{{item.name}} <span class="icon_right"
                                                                                   :class="{'icon_right_rotate':isShowCon==item.id}"></span>
                </p>

                <!-- //需要动画的内容 -->
                <!-- <transition name="fade"> -->
                <div class="con"
                     key="box1"
                     v-if="isShowCon==item.id">
                    <p v-for="(itm,idx) in item.list"
                       :key="idx">{{itm.name?itm.name:'暂无答案'}}</p>
                </div>
                <!-- </transition> -->
            </div>
            <!-- </transition-group> -->
        </div>
        <div class="btn" v-if="packageName && packageName!='com.tcb.TCHelp'">
      <span class="help_btn"
            @click="toShowToast">咨询在线客服</span>
        </div>

        <!--<div class="footer">
            声明：因内容存在时效性等客观原因，若本文登载发布的内容与本平台产品实际不符，请以本平台页面实际展示为准
        </div>-->

        <div class="kefu" v-if="packageName && packageName=='com.tcb.TCHelp'">
            <div>人工客服请点击右下角聊天窗口</div>
        </div>

        <div class="shadow"
             v-if="showToast"></div>
        <div class="toast"
             v-if="showToast">
            <h1 class="title">温馨提示</h1>
            <div class="toast_info">
                在线客服工作时间为<span class="blue">工作日9:00-18:00</span>，非工作时间您可<span class="blue">留言</span>，我们会在上班后尽快处理，感谢您的理解！
            </div>
            <div class="toast_btn">
        <span class="btn_back"
              @click="toHide">返回</span><span class="btn_containue blue"
                                             @click="toHelp">继续咨询</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                showToast: 0,
                isShowCon: '',
                isActive: '0',
                headerList: [
                    {name: '热点问题'}, {name: '贷款问题'}, {name: 'APP相关'}
                ],
                contentList: [
                    {
                        name: '我该如何联系客服？',
                        con: '我该如何联系客服我该如何联系客服我该如何联系客服我该如何联系客服我该如何联系客服我该如何联系客服',
                        show: true,
                    }, {
                        name: '如何注销账号？',
                        con: '如何注销账号？如何注销账号？如何注销账号？如何注销账号？如何注销账号？如何注销账号？如何注销账号？如何注销账号？',
                        show: false,
                    }, {
                        name: '如何修改实名形象',
                        con: '如何修改实名形象如何修改实名形象如何修改实名形象如何修改实名形象如何修改实名形象如何修改实名形象如何修改实名形象如何修改实名形象',
                        show: false,
                    }
                ],
                packageName: "",
            }
        },
        mounted() {
            this.util.title('帮助中心');
            var packageName = localStorage.getItem("packageName");
            if (packageName) {
                this.packageName = packageName;
            }
            if(packageName && packageName=='com.tcb.TCHelp'){
                (function (w, d, n, a, j) {
                    w[n] = w[n] || function () {
                        (w[n].a = w[n].a || []).push(arguments);
                    };
                    j = d.createElement('script');
                    j.async = true;
                    j.src = 'https://qiyukf.com/script/3f9a2096a3b5dc05c7525429aab70eda.js';
                    d.body.appendChild(j);
                })(window, document, 'ysf');
            }
            this.getHelpList();
        },
        methods: {
            toHelp() {
                this.showToast = 0;
                // 跳转到原生客服页面
                this.util.toClientPath(7)
            },
            toShowToast() {
                this.showToast = 1;
            },
            toHide() {
                this.showToast = 0;
            },
            toShowCon(item) {
                this.isShowCon = this.isShowCon == item.id ? '' : item.id;
            },
            toCheckActive(item, index) {
                this.isActive = index;
                this.getHelpCon(item);
            },
            //查询是否授权状态
            getHelpList() {//
                let _this = this;
                let param = {
                    parentId: this.parentId
                }
                this.$get('/app/api/v1/helpCenter/getByParentHelpCenter', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.headerList = e.data;
                            this.getHelpCon(this.headerList[0])
                        } else {
                            _this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                    });
            },
            getHelpCon(item) {
                let _this = this;
                let param = {
                    parentId: item.id
                }
                this.$get('/app/api/v1/helpCenter/getBySonHelpCenter', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.contentList = e.data;
                            this.isShowCon = this.contentList[0].id
                        } else {
                            _this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                    });
            }

        }

    }
</script>
<style scoped>
    .help_box {
        background: #f7f7f7;
        width: 100%;
        /* height: 100%; */
        padding-bottom: 0.5rem;
    }

    .header {
        display: flex;
        justify-content: space-between;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        padding: 0.13rem 0.34rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 0.1rem;
    }

    .header p {
        position: relative;
    }

    .line {
        display: inline-block;
        width: 28px;
        height: 2px;
        background: rgba(79, 140, 250, 1);
        border-radius: 2px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -0.02rem;
    }

    .active {
        color: rgba(79, 140, 250, 1);
    }

    .content {
        background: #fff;
        padding: 0.02rem 0.15rem;
    }

    .item {
        border-top: 1px solid #f5f5f5;
    }

    .item:first-child {
        border-top: 0;
    }

    .item .title {
        color: #333333;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        padding: 0.16rem 0;
        position: relative;
    }

    .item .titleNoPadd {
        padding-bottom: 0.05rem;
    }

    .item .con {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 20px;
        padding-bottom: 0.13rem;
    }

    .fade-leave-to {
        transform: translate3d(0, 0px, 0);
        z-index: -10;
    }

    .fade-enter {
        transform: translate3d(0, -10px, 0);
    }

    .fade-leave-active,
    .fade-enter-active {
        transition: 0.1s all ease;
    }

    .icon_right {
        display: inline-block;
        width: 0.12rem;
        height: 0.1rem;
        background: url('../../assets/img/common/icon_right.png') no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        top: 0.24rem;
        right: 0;
    }

    .icon_right_rotate {
        transform: translateY(-50%) rotate(180deg);
    }

    .btn {
        margin-top: 0.3rem;
        text-align: center;
    }

    .help_btn {
        display: inline-block;
        margin: 0 auto;
        width: 345px;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        padding: 0.12rem 0;
    }

    .shadow {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 11;
    }

    .toast {
        position: absolute;
        left: 50%;
        top: 1.62rem;
        transform: translate(-50%, 0%);
        z-index: 12;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        width: 2.95rem;
    }

    .toast .title {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        margin: 0.2rem 0 0.09rem 0;
        text-align: center;
    }

    .toast_info {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 28px;
        padding: 0 0.2rem;
    }

    .blue {
        color: #4f8cfa;
    }

    .toast_btn {
        margin-top: 0.1rem;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #eeeeee;
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
    }

    .toast_btn span {
        text-align: center;
        flex: 1;
        padding: 0.16rem 0;
    }

    .btn_back {
        border-right: 1px solid #eee;
    }

    .move-enter-active,
    .move-leave-active {
        transition: all 0.5s linear;
        transform: translate3d(0, 0, 0);
    }

    .move-enter,
    .move-leave {
        transform: translate3d(100%, 0, 0);
    }

    .footer {
        padding: 0.3rem 0.2rem;
        text-align: center;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #BCBCBC;
    }

    .kefu{
        padding: 0.3rem 0.2rem;
        text-align: center;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #BCBCBC;
    }
</style>

